import { SAButton } from '@saux/design-system-react';
import styled from 'styled-components';
import batch_Acknowledgment from '../../icons/Batch_Acknowledgment.png';
import { NEW_SEARCH, CONVERSATION_CONTROL_TABS, VIEW_CONVERSATIONS, COVER_ALL, COVER } from '../../utils/constants';

const ResponseComponent = styled.div`
    width:500px;
    margin:0 auto;
    margin-top:5%;
    .img{
        margin-left:40%;
    }
    .msg{
        margin-top:20px;
        text-align: center; 
    }
    .b{
        font-weight:bold;
    }
    #action{
        margin:0 auto;
        margin-top: 30px;
        color: white;
        background-color: #65A100;
        font-size: 16px;
    }
`;


export default function DashboardAPIResponsePage(props: any) {
    return (
        <ResponseComponent data-testid="api-response">
            <div className="img" data-testid="icon"><img src={batch_Acknowledgment} alt="#" width={100} height={100}></img></div>
            
                <div className="msg">{props.text}</div>
    
            {
             (props.selectedAction !==COVER && props.selectedAction!==COVER_ALL) &&
             <div className="msg b">QuickText will notify you when the process runs to completion. </div>
            }
           
            {
                props.selectedType === CONVERSATION_CONTROL_TABS.MYCONVERSATIONS ?
                    <SAButton id="action" label={VIEW_CONVERSATIONS} variant="small" onClick={props.handleViewConversations} />
                    : <SAButton id="action" label={NEW_SEARCH} variant="small" onClick={props.handleNewSearch} />
            }
        </ResponseComponent>
    );
}
